module.exports = __webpack_public_path__ + "static/media/postgres.9a1d1fee.png";